
function _s(o, i, p, l) { void 0 === i && (i = 400), void 0 === l && (l = !1), o.style.overflow = "hidden", l && (o.style.display = "block"); var n, t = window.getComputedStyle(o), s = parseFloat(t.getPropertyValue("height")), a = parseFloat(t.getPropertyValue("padding-top")), r = parseFloat(t.getPropertyValue("padding-bottom")), y = parseFloat(t.getPropertyValue("margin-top")), d = parseFloat(t.getPropertyValue("margin-bottom")), g = s / i, m = a / i, h = r / i, u = y / i, x = d / i; window.requestAnimationFrame(function t(e) { void 0 === n && (n = e); e -= n; l ? (o.style.height = g * e + "px", o.style.paddingTop = m * e + "px", o.style.paddingBottom = h * e + "px", o.style.marginTop = u * e + "px", o.style.marginBottom = x * e + "px") : (o.style.height = s - g * e + "px", o.style.paddingTop = a - m * e + "px", o.style.paddingBottom = r - h * e + "px", o.style.marginTop = y - u * e + "px", o.style.marginBottom = d - x * e + "px"), i <= e ? (o.style.height = "", o.style.paddingTop = "", o.style.paddingBottom = "", o.style.marginTop = "", o.style.marginBottom = "", o.style.overflow = "", l || (o.style.display = "none"), "function" == typeof p && p()) : window.requestAnimationFrame(t) }) } HTMLElement.prototype.slideToggle = function (t, e) { 0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e) }, HTMLElement.prototype.slideUp = function (t, e) { _s(this, t, e) }, HTMLElement.prototype.slideDown = function (t, e) { _s(this, t, e, !0) };


class ProductTemplate extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initMedias();


        this.querySelectorAll('.js-product-form-main').forEach((button) => {
            button.addEventListener('submit', this.addToCart.bind(this));
        });


        if (this.querySelector('.product-info__toggle')) {
            this.initToggles();
        }

        if (this.querySelector('.product-upsell__content')) {
            this.initUpsell();
        }

        if (this.querySelector('.review-custom__content')) {
            this.initReviews();
        }

        if (this.querySelector('.product-collapse__container')) {
            if (this.querySelector('.swiper-collapse-reseller')) {
                this.swiperCollapse = new Swiper(this.querySelector('.swiper-collapse-reseller'), {
                    autoplay: {
                        enabled: true,
                        delay: 0,
                        pauseOnMouseEnter: false,
                        disableOnInteraction: false,
                    },
                    loop: true,
                    speed: 10000,
                    slidesPerView: 'auto',
                });
            }

            this.querySelectorAll(".faq-item-title").forEach((button) => {
                button.addEventListener("click", this.toggleFaqItem.bind(this));
            });
        }

        if (this.querySelector('.product-info__reduction-wrapper')) {
            this.querySelectorAll('.product-info__reduction-wrapper input').forEach((input) => {
                input.addEventListener('change', this.updatePrice.bind(this));
            });
        }

        // if (this.querySelector('.product-collapse__container')) {
        //     this.initCollapse();
        // }

        if (this.querySelector('.product-sticky__submit')) {

            window.addEventListener('scroll', () => {
                if (this.querySelector('.js-product-form-main').getBoundingClientRect().top < 0) {
                    this.querySelector('.product-sticky__container ').classList.add('active');
                    document.body.classList.add('sticky-active');
                } else {
                    this.querySelector('.product-sticky__container ').classList.remove('active');
                    document.body.classList.remove('sticky-active');
                }
            });

            this.querySelector('.product-sticky__submit').innerHTML = this.querySelector('.product-info__add-button').innerHTML;
            this.querySelector('.product-sticky__submit button').addEventListener('click', function (e) {
                document.querySelector('.js-product-form-main').dispatchEvent(new Event('submit'));
            })
        }

        if (this.querySelector('.product-sticky__variants--select')) {
            document.querySelector('.product-sticky__variants--select').addEventListener('change', this.changeBottomSelect.bind(this));
        }
    }

    changeBottomSelect(event) {
        let value = event.target.value;
        this.querySelectorAll('.option-selector:first-child input').forEach((select) => {
            if (select.value == value) {
                select.click();
            }
        })

        if (this.querySelector('.product-sticky__submit')) {
            this.querySelector('.product-sticky__submit').innerHTML = this.querySelector('.product-info__add-button').innerHTML;
            this.querySelector('.product-sticky__submit button').addEventListener('click', function (e) {
                document.querySelector('.js-product-form-main').dispatchEvent(new Event('submit'));
            })
        }

    }

    initReviews() {
        this.swiperReviews = new Swiper(this.querySelector('.swiper-review-min'), {
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: this.querySelector('.swiper-review-min .swiper-button-next'),
                prevEl: this.querySelector('.swiper-review-min .swiper-button-prev'),
            },
            pagination: {
                el: this.querySelector('.swiper-review-min .swiper-pagination'),
                clickable: true,
            },
        });
    }

    toggleFaqItem(e) {
        e.currentTarget
            .querySelector(".faq-close")
            .classList.toggle("faq-display-none");

        e.currentTarget.parentNode.classList.toggle("faq-item-active");

        const item = e.currentTarget.parentNode.querySelector(".faq-item-text");
        console.log(item);



        item.slideToggle("250");

        if (item.closest('.product-collapse__revendeur-wraper')) {
            if (item.closest('.product-collapse__revendeur-wraper').classList.contains('active')) {
                this.swiperCollapse.autoplay.stop();
            } else {
                this.swiperCollapse.autoplay.start();
            }
        }
    }


    updatePrice(event) {
        document.querySelector('variant-picker').handleVariantChange();
        document.querySelector('.product-sticky__submit').innerHTML = document.querySelector('.product-info__add-button').innerHTML;
       this.querySelector('.product-sticky__submit button').addEventListener('click', function (e) {
          document.querySelector('.js-product-form-main').dispatchEvent(new Event('submit'));
        })
    }

    initUpsell() {
        this.swiperUpsell = new Swiper(this.querySelector('.product-upsell__content'), {
            direction: 'horizontal',
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: this.querySelector('.product-upsell__header .swiper-button-next'),
                prevEl: this.querySelector('.product-upsell__header .swiper-button-prev'),
            },
            pagination: {
                el: this.querySelector('.product-upsell__header .swiper-pagination'),
                clickable: true,
            },
        });

        document.querySelectorAll('.product-upsell__item-add [data-add-to-cart]').forEach((button) => {
            button.addEventListener('click', this.addToCartUpsell.bind(this));
        });

    }

    addToCartUpsell(event) {
        event.preventDefault();
        let target = event.currentTarget;
        let selections_items = [];
        selections_items.push({
            id: Number(target.dataset.addToCart),
            quantity: 1,
        })

        const data = {
            items: selections_items
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);
            })


    }


    addToCart(event) {
        event.preventDefault();
        let form = event.target;
        let selections_items = [];

        if (this.querySelector('.product-info__reduction-wrapper.active input:checked')) {
            selections_items.push({
                id: Number(form.querySelector('input[name="id"]').value),
                quantity: Number(this.querySelector('.product-info__reduction-wrapper.active input').dataset.productQuantity),
            })
        } else {
            selections_items.push({
                id: Number(form.querySelector('input[name="id"]').value),
                quantity: 1,
            })
        }

        const data = {
            items: selections_items
        }

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        })
            .then(response => response.json())
            .then(data => {
                console.log('Success:', data);
            })

    }

    initMedias() {
        this.swiperThumb = new Swiper(this.querySelector('.thumb-carrousel'), {
            // Optional parameters
            direction: 'horizontal',
            slidesPerView: "auto",
            spaceBetween: 5,
            threshold: 5,
            breakpoints: {
                990: {
                    spaceBetween: 0,
                },
            },
        });

        this.swiper = new Swiper(this.querySelector('.main-carrousel'), {
            direction: 'horizontal',
            slidesPerView: "auto",
            spaceBetween: 10,
            thumbs: {
                swiper: this.swiperThumb,
                slideThumbActiveClass: 'swiper-slide-thumb-active',
            },
            navigation: {
                nextEl: this.querySelector('.main-carrousel .swiper-button-next'),
                prevEl: this.querySelector('.main-carrousel .swiper-button-prev'),
            },
        });
    }

    initToggles() {
        this.querySelectorAll('.product-info__toggle-title').forEach((toggleTitle) => {
            toggleTitle.addEventListener('click', () => {
                let toggleData = toggleTitle.dataset.toggle;
                let toggleContent = this.querySelector(`.product-info__toggle-content[data-toggle="${toggleData}"]`);

                this.querySelectorAll('.product-info__toggle-content').forEach((content) => {
                    content.classList.remove('active');
                });

                this.querySelectorAll('.product-info__toggle-title').forEach((title) => {
                    title.classList.remove('active');
                });

                toggleContent.classList.add('active');
                toggleTitle.classList.add('active');

            });
        });
    }
}

customElements.define('product-template', ProductTemplate);




function initJdgm() {
    const widgetHeader = document.querySelector('.jdgm-rev-widg__header');
    let header = document.createElement('div');
    header.classList.add('header-jdgm');

    let header_content = document.createElement('div');
    header_content.classList.add('header__content-jdgm');
    widgetHeader.classList.add('hidden');

    let buttons = document.createElement('div');
    buttons.classList.add('header__buttons-jdgm');

    const summary = document.querySelector('.jdgm-rev-widg__summary');
    const actions = document.querySelector('.jdgm-widget-actions-wrapper');

    if (summary) {
        let rating = document.querySelector('.jdgm-rev-widg').getAttribute('data-average-rating');
        buttons.appendChild(summary.cloneNode(true));
        let average_rating = document.createElement('span')
        let average_rating_text = document.createElement('span')
        average_rating_text.classList.add('header__average-rating-jdgm');
        average_rating.classList.add('header__average-rating-jdgm');
        average_rating.textContent = rating;
        average_rating_text.textContent = rating;
        buttons.querySelector('.jdgm-rev-widg__summary-stars').appendChild(average_rating);
        document.querySelector('.hidden .jdgm-rev-widg__summary-stars').appendChild(average_rating_text);
    } else {
        console.warn("Élément '.jdgm-rev-widg__summary' introuvable");
    }

    if (actions) {
        buttons.appendChild(actions.cloneNode(true));
    } else {
        console.warn("Élément '.jdgm-widget-actions-wrapper' introuvable");
    }

    let histogram = document.createElement('div');
    histogram.classList.add('header__histogram-jdgm');

    const histogram_jdgm = document.querySelector('.jdgm-histogram');

    if (histogram_jdgm) {
        histogram.appendChild(histogram_jdgm.cloneNode(true));
    } else {
        console.warn("Élément '.jdgm-histogram' introuvable");
    }

    let galerie = document.createElement('div');
    galerie.classList.add('header__galery-jdgm');

    const galerie_jdgm = document.querySelector('.jdgm-gallery');

    if (galerie_jdgm) {
        galerie.appendChild(galerie_jdgm.cloneNode(true));
    } else {
        console.warn("Élément '.jdgm-gallery' introuvable");
    }

    let header_title = document.createElement('div');
    header_title.classList.add('header__title-jdgm');
    let header_subtitle = document.createElement('h3');
    header_subtitle.classList.add('header__subtitle-jdgm');
    header_subtitle.classList.add('t3');
    let header_subtitle_2 = document.createElement('h3');
    header_subtitle_2.classList.add('header__subtitle-jdgm');
    header_subtitle_2.classList.add('t3');
    const title = document.querySelector('.jdgm-rev-widg__title');
    header_subtitle.innerHTML = '+100k clients <strong>nous font confiance</strong>';
    header_subtitle_2.innerHTML = '+100k clients <strong>nous font confiance</strong>';

    if (title) {
        header_title.appendChild(title.cloneNode(true));
        header_title.appendChild(header_subtitle_2);
        document.querySelector('.jdgm-rev-widg__header.hidden').appendChild(header_subtitle);
    } else {
        console.warn("Élément '.jdgm-rev-widg__title' introuvable");
    }

    header_content.appendChild(header_title);
    header_content.appendChild(buttons);
    header_content.appendChild(histogram);
    header_content.appendChild(galerie);


    header.appendChild(header_content);
    let header_container = document.createElement('div');
    header_container.classList.add('jdgm-rev-widg__header');
    header_container.appendChild(header);

    document.querySelector('.jdgm-rev-widg').appendChild(header_container);

    let count = document.createElement('p')
    count.classList.add('jdgm-count-reviews');

    document.querySelector('.header-jdgm .jdgm-write-rev-link').addEventListener('click', function (e) {
        e.preventDefault();
        if (document.querySelector('.hidden .jdgm-form-wrapper').classList.contains('open')) {
            document.querySelector('.hidden .jdgm-form-wrapper').classList.remove('open');
        } else {
            document.querySelector('.hidden .jdgm-form-wrapper').classList.add('open');
        }
    });

    let couunt_ammount = document.querySelector('.jdgm-rev-widg').getAttribute('data-number-of-reviews');

    count.textContent = 'Avis Clients (' + couunt_ammount + ')';

    document.querySelector('.jdgm-rev-widg__sort-wrapper').appendChild(count);

    document.querySelectorAll('.header-jdgm .jdgm-gallery__thumbnail').forEach((elem) => {
        elem.setAttribute('src', elem.getAttribute('data-src'));
    });

    document.querySelectorAll('.header-jdgm .jdgm-gallery__thumbnail-wrapper').forEach((elem) => {
        elem.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation()
            let image = elem.querySelector('img').getAttribute('data-review-id');
            document.querySelector(`.hidden .jdgm-gallery__thumbnail[data-review-id="${image}"]`).click();
        });
    });


    document.querySelectorAll('.header-jdgm .jdgm-histogram__row').forEach((elem) => {
        elem.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation()
            let rating = elem.getAttribute('data-rating');
            document.querySelector(`.hidden .jdgm-histogram__row[data-rating="${rating}"]`).click();
        });
    });
}

window.addEventListener("load", function () {
    initJdgm();
});

